import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ChatWindow from '../chat/ChatWindow';

const MEDIA_BASE = 'https://buzzinguniverse.com/backend/';

function GroupChat({ group, auth }) {
    const isAdmin    = group.membership?.role === 'admin';
    const isCompany  = group.type === 'company';

    const [chatRoom, setChatRoom]           = useState(null);
    const [loading, setLoading]             = useState(true);
    const [companyInbox, setCompanyInbox]   = useState([]);
    const [selectedChat, setSelectedChat]   = useState(null);

    useEffect(() => {
        if (!auth?.id) return;
        setLoading(true);
        if (!isCompany) {
            fetchGroupChatRoom();
        } else if (isAdmin) {
            fetchCompanyInbox();
        } else {
            fetchCompanyRoomId();
        }
    }, [group.id, auth?.id]);

    const fetchGroupChatRoom = async () => {
        try {
            const res = await axios.get(`${MEDIA_BASE}api/get-group-chat-room?group_id=${group.id}&user_id=${auth.id}`);
            if (res.data.status) {
                const room = res.data.data.chat_room;
                setChatRoom({ chat_id: room.id, type: 'group', group });
            }
        } catch (err) {
            console.error('Error fetching group chat room:', err);
        } finally {
            setLoading(false);
        }
    };

    const fetchCompanyRoomId = async () => {
        try {
            const res = await axios.get(`${MEDIA_BASE}api/get-company-room-id?company_id=${group.id}&user_id=${auth.id}`);
            if (res.data.status) {
                const room = res.data.data.chat_room;
                setChatRoom({ chat_id: room.id, type: 'company', group });
            }
        } catch (err) {
            console.error('Error fetching company room:', err);
        } finally {
            setLoading(false);
        }
    };

    const fetchCompanyInbox = async () => {
        try {
            const res = await axios.get(`${MEDIA_BASE}api/get-company-inbox?company_id=${group.id}&admin_id=${auth.id}`);
            if (res.data.status) {
                const inbox = res.data.data;
                setCompanyInbox(inbox);
                if (inbox.length > 0 && !selectedChat) {
                    setSelectedChat({ chat_id: inbox[0].chat_id, type: 'company', group, user: inbox[0].user });
                }
            }
        } catch (err) {
            console.error('Error fetching company inbox:', err);
        } finally {
            setLoading(false);
        }
    };

    const currentUserName = `${auth?.fname || ''} ${auth?.lname || ''}`.trim() || 'Someone';

    if (loading) return <div className="loading" />;

    if (!isCompany || !isAdmin) {
        if (!chatRoom) return <p style={{ padding: '20px', color: '#888' }}>Unable to load chat room.</p>;
        return (
            <div style={{ height: '600px', display: 'flex', flexDirection: 'column' }}>
                <ChatWindow
                    chat={chatRoom}
                    currentUser={auth.id}
                    currentUserName={currentUserName}
                    onRefreshChats={() => {}}
                />
            </div>
        );
    }

    return (
        <div style={{ display: 'flex', height: '600px', border: '1px solid #eee', borderRadius: '8px', overflow: 'hidden' }}>
            <div style={{ width: '280px', borderRight: '1px solid #eee', overflowY: 'auto', background: '#fafafa', flexShrink: 0 }}>
                <div style={{ padding: '12px 16px', fontWeight: 600, borderBottom: '1px solid #eee', fontSize: '0.95rem' }}>
                    Company Inbox
                </div>
                {companyInbox.length === 0 ? (
                    <div style={{ padding: '20px', color: '#888', textAlign: 'center' }}>No messages yet</div>
                ) : companyInbox.map(item => (
                    <div
                        key={item.chat_id}
                        onClick={() => setSelectedChat({ chat_id: item.chat_id, type: 'company', group, user: item.user })}
                        style={{
                            padding: '12px 16px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0',
                            background: selectedChat?.chat_id === item.chat_id ? '#e8f4ff' : 'transparent',
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <img
                                src={item.user?.photo ? `${MEDIA_BASE}${item.user.photo}` : '/images/default.png'}
                                alt=""
                                style={{ width: 36, height: 36, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                            />
                            <div style={{ overflow: 'hidden', flex: 1 }}>
                                <div style={{ fontWeight: 500, fontSize: '0.88rem' }}>
                                    {item.user?.first_name} {item.user?.last_name}
                                </div>
                                <div style={{ fontSize: '0.78rem', color: '#888', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {item.last_message || 'No messages yet'}
                                </div>
                            </div>
                            {item.unread_count > 0 && (
                                <span style={{ background: '#0d6efd', color: '#fff', borderRadius: '999px', fontSize: '0.7rem', padding: '2px 6px', flexShrink: 0 }}>
                                    {item.unread_count}
                                </span>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            <div style={{ flex: 1, overflow: 'hidden' }}>
                {selectedChat ? (
                    <ChatWindow
                        chat={selectedChat}
                        currentUser={auth.id}
                        currentUserName={currentUserName}
                        onRefreshChats={fetchCompanyInbox}
                    />
                ) : (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#888' }}>
                        Select a conversation from the inbox
                    </div>
                )}
            </div>
        </div>
    );
}

export default GroupChat;
